<template>
  <div>
    <b-notification
      v-for="(error, index) in errors"
      v-bind:key="index"
      type="is-danger"
      aria-close-label="Close notification"
      role="alert"
      >{{ error.message }}</b-notification
    >
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(changePassword)">
        <b-field :label="$t('Código')">
          <ValidationProvider
            name="Código"
            rules="required"
            v-slot="{ errors }"
          >
            <b-input v-model="form.authCode" />
            <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
          </ValidationProvider>
        </b-field>

        <ValidationProvider
          name="Contraseña"
          rules="required|min:8|verify_password|password:@confirm"
          v-slot="{ errors }"
        >
          <b-field :label="$t('Contraseña')">
            <b-input
              v-model="form.password"
              type="password"
              password-reveal
              name="password"
            />
          </b-field>
          <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
        </ValidationProvider>

        <ValidationProvider name="confirm" rules="required" v-slot="{ errors }">
          <b-field :label="$t('Confirmar Contraseña')">
            <b-input
              v-model="form.confirmation"
              type="password"
              password-reveal
            />
          </b-field>
          <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
        </ValidationProvider>

        <b-field style="text-align: center;">
          <button
            native-type="submit"
            class="button is-pink is-full-w"
            :class="{ 'is-loading': isLoading }"
          >
            {{ $t('Login') }}
          </button>
        </b-field>
        <b-field>
          <div class="control" style="margin-top: 10px;">
            <p>
              <a v-on:click="goToContact" class="customLink is-size-6"
                >{{ $t('Registrarme') }} |</a
              >
              <a v-on:click="goToRecover" class="customLink is-size-6">{{
                $t('He olvidado mi contraseña')
              }}</a>
            </p>
          </div>
        </b-field>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, alpha, numeric, email, min } from 'vee-validate/dist/rules'

extend('verify_password', value => {
  var strongRegex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$()%^&*])(?=.{8,})'
  )
  if (strongRegex.test(value)) {
    return true
  }

  return 'La contraseña debe contener al menos un dígito, un caracter especial y una mayúscula'
})

extend('min', {
  ...min
})

extend('required', {
  ...required
})

extend('alpha', {
  ...alpha
})

extend('numeric', {
  ...numeric
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Las contraseñas no coinciden'
})

extend('email', {
  ...email
})

export default {
  name: 'ChangePassword',
  props: ['email'],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {},
  data() {
    return {
      errors: [],
      form: {
        password: '',
        authCode: '',
        confirmation: ''
      }
    }
  },
  methods: {
    goToSignIn() {
      this.$router.push({ name: 'sign-in' })
    },
    goToRecover() {
      this.$router.push({ name: 'forgot' })
    },
    goToContact() {
      window.location.href = 'https://myneofintech.com/myneofintech/contacto/'
    },
    async changePassword() {
      let self = this
      const email = self.email
      const authCode = self.form.authCode
      const password = self.form.password
      await Auth.forgotPasswordSubmit(email, authCode, password)
        .then(function() {
          self.$toast.open({
            duration: 5000,
            message: self.$t('Contraseña actualizada correctamente'),
            position: 'is-bottom',
            type: 'is-success'
          })
          self.$router.push({
            name: 'sign-in'
          })
        })
        .catch(err => console.log(err))
    }
  }
}
</script>

<style>
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin: 0 auto;
}
.input {
  margin-bottom: 7px;
  height: 38px;
  border: none;
  outline: none;
  border-bottom: 2px solid #ddd;
  font-size: 20px;
}
</style>
